import { useQuery } from '@tanstack/react-query';
import { useCurrentUserQuery } from 'hooks/useCurrentUserQuery';
import { ApiUserRepository } from 'services/repositories/implementations/ApiUserRepository';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { isAccessTokenSet } from 'utils/authentication';
import { QueryKeys } from 'utils/queryKeys';

const apiUserRepository = new ApiUserRepository();

export const useGetPreviewGridByContentId = (contentId: string) => {
  const { data: userData } = useCurrentUserQuery(apiUserRepository, { enabled: isAccessTokenSet() });

  const { status, data } = useQuery({
    queryKey: QueryKeys.getGridsByContentId(contentId),
    queryFn: async () => {
      return apiDocumentServiceRepository.getSectionsByContentId(contentId);
    },
    enabled: Boolean(contentId),
  });

  return { status, data, userData };
};
